export default {
  title: "我的工單",
  refresh: "重新整理",
  create: "建立",
  id: "工單 ID",
  type: "類型",
  status: "狀態",
  createdAt: "建立時間",
  actions: "操作",
  detailTitle: "工單詳情",
  email: "電子郵箱",
  description: "描述",
  response: "回覆",
  noResponse: "暫無回覆",
  statusPending: "待處理",
  statusResolved: "已解決",
  statusClosed: "已關閉",
};
